import { render, staticRenderFns } from "./newMeal.vue?vue&type=template&id=24294442&"
import script from "./newMeal.vue?vue&type=script&lang=js&"
export * from "./newMeal.vue?vue&type=script&lang=js&"
import style0 from "./newMeal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports